import React from 'react';

import './OrderedListItemStyle.less';

interface IOrderedListItem {
  index: number;
}

const OrderedListItem: React.SFC<IOrderedListItem> = props => (
  <div className="od-ordered-list-item">
    <div className="od-ordered-list-item__index">{props.index}</div>
    <div className="od-ordered-list-item__content">{props.children}</div>
  </div>
);

export default OrderedListItem;
